
import React, { useEffect, useState } from "react";
import {
  Row,
  Input,
  Typography,
  Form,
  Col,
  DatePicker,
  Divider,
  Avatar,
  Spin,
  Space,
  Button,
} from "antd";
import { UserRound } from "lucide-react";
import { FONT } from "constants/index";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import {
  notificationErroInternal,
  notificationSucess,
} from "util/api-utils";
import {
  getReviewUserOpenById,
  putReview,
} from "services/review/review-service";

dayjs.extend(duration);

const { Text } = Typography;
const dateFormat = "DD/MM/YYYY";

const FormNewUserReviewAqua = (props) => {
  const [form] = Form.useForm();
  const [loadingData, setLoadingData] = useState(false);
  const [imgAvatar, setImgAvatar] = useState("");

  useEffect(() => {
    setLoadingData(true);
    setImgAvatar(props.user?.img);
    form.setFieldsValue({
      name: props.user?.name,
    });
    if (props.editRow) {
      const row = props.editRow;
      form.setFieldsValue({
        name: props.user.name,
        date: row.reviewDate ? dayjs(row.reviewDate) : null,
        load1: (row.load1+"").replace(".",","),
        vmp1: (row.vmp1+"").replace(".",",")
      });
      setLoadingData(false);
    }
    setLoadingData(false);
  }, [props]);

  const handleNewReview = () => {
    setLoadingData(true);

    form
      .validateFields()
      .then((values) => {
        values.id = props.editId;
        if (values.load1) values.load1 = values.load1.replace(",", ".");
        if (values.vmp1) values.vmp1 = values.vmp1.replace(",", ".");
        values.userId = props.user.id;
        values.date = values.date.format(dateFormat);
        putReview(values)
          .then(() => {
            setLoadingData(false);
            if (props.onClose) {
              props.onClose(props.user.id, props.listClosed);
            }
            if (props.getData) {
              props.getData();
            } else {
              notificationSucess();
            }
            form.resetFields();
          })
          .catch(() => {
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde."
            );
            setLoadingData(false);
          });
      })
      .catch(() => {
        setLoadingData(false);
      });
  };

  const onCloseDrawer = () => {
    props.onClose(props.user.id, props.listClosed);
  };

  const parseMinCommaSec = (value) => {
    if (!value) return null;
    const parts = value.split(",");
    const minutes = parseInt(parts[0], 10) || 0;
    const seconds = parseInt(parts[1], 10) || 0;
    return minutes * 60 + seconds;
  };

  const formatToMinCommaSec = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes},${seconds.toString().padStart(2, "0")}`;
  };

  const changeTime = () => {
    const rawValue = form.getFieldValue("load1");
    const totalSeconds = parseMinCommaSec(rawValue);

    if (totalSeconds !== null) {
      const avgSeconds = Math.floor(totalSeconds / 10);
      const formatted = formatToMinCommaSec(avgSeconds);

      form.setFieldsValue({
        vmp1: formatted,
      });
    } else {
      form.setFieldsValue({ vmp1: null });
    }
  };

  return (
    <>
      <Spin spinning={loadingData}>
        <Form form={form} layout="vertical">
          <Row justify="end" style={{ marginBottom: "25px" }}>
            <Space>
              <Button style={{ fontFamily: FONT }} onClick={onCloseDrawer}>
                Cancelar
              </Button>
              <Button
                style={{ fontFamily: FONT }}
                onClick={handleNewReview}
                type="primary"
              >
                Salvar
              </Button>
            </Space>
          </Row>

          <Row gutter={16} style={{ textAlign: "center", marginBottom: "30px" }}>
            <Col span={24}>
              <Avatar
                src={imgAvatar}
                icon={<UserRound size={120} />}
                size={120}
              />
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label={<span style={{ fontFamily: FONT }}>Aluno</span>}
              >
                <Input disabled style={{ fontFamily: FONT }} />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="date"
                label={<span style={{ fontFamily: FONT }}>Data</span>}
                rules={[
                  {
                    required: true,
                    message: "É necessário informar a data da avaliação",
                  },
                ]}
              >
                <DatePicker
                  style={{ fontFamily: FONT, width: "100%" }}
                  placeholder={["", ""]}
                  format={dateFormat}
                  suffixIcon={null}
                />
              </Form.Item>
            </Col>
          </Row>

          <Divider />

          <Row gutter={16} style={{ marginTop: "15px" }}>
            <Col span={12}>
              <Form.Item
                name="load1"
                label={<span style={{ fontFamily: FONT }}>Tempo (min,seg)</span>}
              >
                <Input
                  style={{ fontFamily: FONT, width: "100%" }}
                  onBlur={changeTime}
                  placeholder="mm,ss"
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="vmp1"
                label={<span style={{ fontFamily: FONT }}>Média (min,seg)</span>}
              >
                <Input disabled style={{ fontFamily: FONT, width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </>
  );
};

export default FormNewUserReviewAqua;
